import React, { useEffect, useState } from 'react'
import { GetEmailTokenHelper } from '../../../Ancillary/EmailToken/helper/EmailTokenHelper';
import { useLocation } from "react-router-dom";
import { Box } from '@mui/material';
import BackdropMeepl from '../../../Ancillary/AnimationComponents/BackdropMeepl';
import CustomTokenNotFound from '../../../Base/views/CustomTokenNotFound';

import { useRef } from "react";
import { IconButton } from "@mui/material";
import GetAppIcon from "@mui/icons-material/GetApp";
import { toast } from "react-toastify";
import VisitorInviteQR from "./VisitorInviteQR";
import history from '../../../../../history';

const GuestPassDownload = () => {
  const [loadingToken, setTokenLoading] = useState(false);
  const [tokenData, setTokenData] = useState(null);
  const [tokenNotFound, setTokenNotFound] = useState(false);
  const location = useLocation();
  const qrRef = useRef(null);
  const [tokenId, setTokenId] = useState("")
  useEffect(() => {
    setTokenNotFound(false);
    
    const params = new URLSearchParams(location?.search);
    let token = params?.get("token");
    if (!token && location.search) {
      const rawQuery = decodeURIComponent(location.search.slice(1));
      const firstEntry = params.entries().next();
      if (!firstEntry.done) {
        const [key, value] = firstEntry.value;
        if (value) {
          token = `${key}=${value}`;
        } else {
          token = key;
        }
      } else {
        token = rawQuery;
      }
    }

    if (token) {
      const [, domain_name] = token?.split("=");
      setTokenLoading(true);
      GetEmailTokenHelper({
        domain: domain_name,
        token
      }).then((res) => {
        if (res?.data?.statuscode === 200 && res?.data?.data?.[0]?.token) {
          setTokenData(res?.data?.data?.[0]?.json_data?.[0]);
          setTokenId(token)
        } else {
          setTokenNotFound(true);
        }
      }).finally(() => {
        setTokenLoading(false);
      });
    } else {
      setTokenNotFound(true);
    }
  }, [location?.search])

  const downloadQR = async () => {
  try {
    const element = qrRef.current;

    if (!element) return;

    const html2canvas = (await import("html2canvas")).default;

    const canvas = await html2canvas(element, {
      scale: 3,
      useCORS: true,
      backgroundColor: "#ffffff",
    });

    const url = canvas.toDataURL("image/png");

    const link = document.createElement("a");
    link.href = url;
    link.download = `${tokenData?.[0]?.visitors_name || "visitor"}-check-in-qr.png`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => {
      history.push("/")
    }, 3000);
  } catch (err) {
    console.error(err);
    toast.error("Failed to download invite.");
  }
};

  return (
    <Box sx={{ width: "100%", height: "100vh" }}>
      <BackdropMeepl open={loadingToken} dark={false}/>
      {!loadingToken && tokenNotFound && <CustomTokenNotFound 
        title="Invalid or Expired Access Link"
        description="The visitor pass link you used is either invalid, has expired or has already been used. Please contact your host or request a new visitor pass to continue."
        ButtonText="Back"
      />}

      {!loadingToken && !tokenNotFound && tokenData && (
        <Box
          sx={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            p: 2,
            background: "#f5f7fa",
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: "100%",
              maxWidth: "520px",
            }}
          >
            <IconButton
              className="mpl-primary-btn"
              onClick={downloadQR}
              sx={{
                position: "absolute",
                top: 10,
                right: -10,
                zIndex: 10,
                boxShadow: 2,
              }}
            >
              <GetAppIcon />
            </IconButton>

            <Box
              ref={qrRef}
              sx={{
                background: "#fff",
                borderRadius: 2,
                p: 2,
                transform: "scale(0.85)", 
                transformOrigin: "top center",
              }}
            >
              <VisitorInviteQR
                invitedBy={tokenData?.employee_id?.name || ""}
                name={tokenData?.visitors_name || ""}
                purpose={tokenData?.visitors_management_reasons_pk?.reason || ""}
                phone={tokenData?.visitors_mobile_no || ""}
                locationTitle={tokenData?.org_name || ""}
                validFrom={tokenData?.booking_date || ""}
                validTo={tokenData?.booking_date || ""}
                qrCodeUrl={tokenId || ""}
              />
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default GuestPassDownload